import { render } from "./svg-gift.vue?vue&type=template&id=3de00f02"
import script from "./svg-gift.vue?vue&type=script&lang=ts"
export * from "./svg-gift.vue?vue&type=script&lang=ts"
script.render = render

export default script